import React from 'react'
import Link from 'gatsby-link'
import Logo from '../ww-logo'
import Bus from '../../utils/bus'
import ClassNames from 'classnames'
import scrollTo from 'gatsby-plugin-smoothscroll'
import { navigateTo } from 'gatsby-link'
let BUS = new Bus()

import CartButton from './cart-button'

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logoAnimating: true,
      shopBtnVisible: true,
      introHeight: 0,
      withinThreshold: true,
      shopOrBuy: 'Shop'
    };
    this.openNav = this.openNav.bind(this);
    this.setDimensions = this.setDimensions.bind(this);
    this.updatePosition = this.updatePosition.bind(this);
    this.gotoShop = this.gotoShop.bind(this);
    this.scrollToMissionBit = this.scrollToMissionBit.bind(this);
  }

  componentDidMount() {
    if (typeof window !== `undefined`) {
      BUS.listen("update-position", this.updatePosition);
      window.addEventListener("resize", this.setDimensions);
      this.setDimensions();
    }
    if (this.props.location.search.indexOf("nav=open") >= 0) {
      setTimeout(() => {
        this.openNav();
      }, 200);
    }
    if (this.props.location.pathname === "/buy") {
      this.setState({ shopBtnVisible: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname === "/buy") {
      this.setState({ shopBtnVisible: false });
    } else {
      this.setState({ shopBtnVisible: true });
    }
  }

  setDimensions() {
    if (typeof window !== `undefined`) {
      const windowH = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );

      let spreadEl = document.getElementsByClassName("Spread")[0];
      let h = 0;
      if (spreadEl !== undefined) {
        h = spreadEl.getBoundingClientRect().height;
      }

      this.setState({
        windowH: windowH,
        introHeight: h
      });
    }
  }

  updatePosition(event) {
    const y = event.detail.position;
    if (y < this.state.introHeight) {
      if (!this.state.withinThreshold) {
        this.setState({
          withinThreshold: true
        });
      }
    } else if (y > this.state.introHeight && this.state.withinThreshold) {
      this.setState({
        withinThreshold: false
      });
    }
  }

  gotoShop() {
    navigateTo("/buy");
  }

  openNav() {
    BUS.trigger("OPEN_NAV");
  }

  scrollToMissionBit(event) {
    event.preventDefault();
    let path = window.location.pathname;
    if (path === "/" || path === "/prelaunch") {
      BUS.trigger("ANIMATED_SCROLL_TO_MISSION");
    }
  }

  openCart() {
    BUS.trigger("OPEN_CART");
  }

  render() {
    return (
      <div className="Nav">
        <div className="bar">
          <Link className="logo" to="/">
            <img className="Logo" src="/images/yf-logo.png" alt="logo" />
          </Link>
          {this.state.shopBtnVisible && (
            <Link to="/buy" className="nav-link">
              Shop
            </Link>
          )}
          {this.state.shopBtnVisible && (
            <a onClick={() => scrollTo('#mission')} className="nav-link">Our Social Mission</a>
          )}
          {this.state.shopBtnVisible && <CartButton openCart={this.openCart} />}
          {this.state.shopBtnVisible && (
            <button className="nav-toggle" onClick={this.openNav}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.19 9.92">
                <path d="M0 3.97h13.19v1.98H0zM0 0h13.19v1.98H0zM0 7.94h13.19v1.98H0z" />
              </svg>
            </button>
          )}
        </div>

        {false && this.state.shopBtnVisible && (
          <Link
            to="/buy"
            className={ClassNames("Btn shop", {
              "is-visible": !this.state.withinThreshold
            })}
          >
            BUY NOW
          </Link>
        )}
      </div>
    );
  }
}

export default NavBar;
//



// WEBPACK FOOTER //
// ./src/components/nav/nav-bar.js